import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useMutateError } from "@features/errors";
import { Order } from "@models/Order";
import client from "@services/api";

import { orderSetsKeyFactory } from "../../../queries/orderSetQueries";
import useOrderSetId from "../useOrderSetId";

export default function useDeleteOrder() {
  const setError = useMutateError();
  const queryClient = useQueryClient();
  const orderSetId = useOrderSetId();

  const queryKey = orderSetsKeyFactory.detail(orderSetId)._ctx.orders.queryKey;

  return useMutation({
    mutationFn: (orderId: string) => {
      return client.remove(`orders/${orderId}`).then(() => ({ orderId }));
    },
    onMutate: async (orderId: string) => {
      await queryClient.cancelQueries({ queryKey });

      const previousOrders = queryClient.getQueryData<Order[]>(queryKey);

      queryClient.setQueryData<Order[]>(queryKey, (orders) => {
        return orders && orders.filter((o) => o.id !== orderId);
      });

      return { previousOrders };
    },
    onError: (err, _orderId, context) => {
      setError(err, "Delete Order");

      if (context) queryClient.setQueryData(queryKey, context.previousOrders);
      queryClient.invalidateQueries({
        queryKey: orderSetsKeyFactory.detail(orderSetId).queryKey,
      });
    },
  });
}
